import { render, staticRenderFns } from "./LiveCreatePage.vue?vue&type=template&id=7a9f0652"
import script from "./LiveCreatePage.vue?vue&type=script&lang=js"
export * from "./LiveCreatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports